module.exports = __webpack_public_path__ + "img/6a133a9.png";